import React, { useState, useEffect, useRef } from 'react';
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
// import axios from 'axios'; // API call ke liye add kiya hai

const AdminLayout = () => {
    const location = useLocation();
    const navigate = useNavigate();

    // --- STATE MANAGEMENT ---
    const [showSidebar, setShowSidebar] = useState(false);
    const [showNotifications, setShowNotifications] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const notifRef = useRef(null);

    // ✅ FAST LOAD LOGIC
    const savedAdmin = localStorage.getItem("adminUser");
    const parsedAdmin = savedAdmin ? JSON.parse(savedAdmin) : null;

    const [admin, setAdmin] = useState(parsedAdmin);
    const [loading, setLoading] = useState(!parsedAdmin);

    // ✅ LIVE NOTIFICATIONS STATE
    const [notifications, setNotifications] = useState([]);

    // AUTH CHECK & NOTIFICATIONS FETCH
    useEffect(() => {
        const token = localStorage.getItem("token");
        if (!token) {
            navigate('/win11-control-room/login');
            return;
        }

        if (!parsedAdmin) {
            setTimeout(() => {
                const adminData = { name: "Super Admin", role: "Owner Access" };
                setAdmin(adminData);
                localStorage.setItem("adminUser", JSON.stringify(adminData));
                setLoading(false);
            }, 800);
        } else {
            setLoading(false);
        }

        // --- FETCH LIVE NOTIFICATIONS FROM BACKEND ---
        const fetchNotifications = async () => {
            try {
                // Yahan backend ka notification route daalna baad me
                // Example: const { data } = await axios.get('http://localhost:5000/api/admin/notifications', { headers: { Authorization: `Bearer ${token}` } });

                // Abhi ke liye empty array set kar diya hai jab tak API nahi banti
                setNotifications([]);
            } catch (error) {
                console.error("Failed to load notifications", error);
            }
        };

        fetchNotifications();
    }, [navigate, parsedAdmin]);

    // Close Notification on Outside Click
    useEffect(() => {
        function handleClickOutside(event) {
            if (notifRef.current && !notifRef.current.contains(event.target)) {
                setShowNotifications(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [notifRef]);

    const handleLogout = () => {
        localStorage.clear();
        sessionStorage.clear();
        navigate('/win11-control-room/login');
    };

    const toggleSidebar = () => setShowSidebar(!showSidebar);
    const closeSidebar = () => setShowSidebar(false);

    // ✨ HELPER: Active Link Style
    const isActive = (path) => {
        const active = location.pathname === path;
        return active
            ? "nav-link active-link d-flex align-items-center mb-2 px-3 py-3 rounded-3 shadow-sm bg-white text-danger"
            : "nav-link inactive-link d-flex align-items-center mb-2 px-3 py-3 rounded-3 text-white-50 hover-white";
    };

    return (
        <div className="container-fluid min-vh-100 d-flex flex-column overflow-hidden" style={{ background: "#f3f4f6" }}>

            {/* --- OVERLAY FOR MOBILE --- */}
            {showSidebar && <div className="sidebar-overlay d-lg-none" onClick={closeSidebar} style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1040 }}></div>}

            <div className="row flex-nowrap min-vh-100">

                {/* ==============================
            SIDEBAR (Premium Design)
        ============================== */}
                <div className={`admin-sidebar-container sidebar-premium d-flex flex-column justify-content-between ${showSidebar ? 'show' : ''} d-lg-flex`} style={{ width: '280px', background: 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)', zIndex: 1050, transition: '0.3s' }}>

                    <div className="d-flex flex-column pt-4 h-100 overflow-hidden">

                        {/* --- BRAND LOGO (FIXED AT TOP) --- */}
                        <div className="d-flex align-items-center mb-4 px-4">
                            <div className="bg-white rounded-3 d-flex align-items-center justify-content-center shadow-sm" style={{ width: '45px', height: '45px', flexShrink: 0 }}>
                                <i className="bi bi-shield-check text-danger fs-3"></i>
                            </div>
                            <div className="ms-3 lh-1">
                                <h5 className="mb-0 fw-bold tracking-wide text-white">WIN11</h5>
                                <small className="text-white-50" style={{ fontSize: '10px', letterSpacing: '1px' }}>CONTROL ROOM</small>
                            </div>
                            <button className="btn btn-sm text-white-50 ms-auto d-lg-none" onClick={closeSidebar}>
                                <i className="bi bi-x-lg fs-5"></i>
                            </button>
                        </div>

                        {/* 🔥 SCROLLABLE MENU WRAPPER */}
                        <div className="custom-scrollbar overflow-auto px-3 pb-4" style={{ flexGrow: 1 }}>

                            {/* --- MENU --- */}
                            <div className="small text-white-50 fw-bold mb-2 px-3 text-uppercase" style={{ fontSize: '11px', letterSpacing: '1px' }}>Main Menu</div>

                            <ul className="nav nav-pills flex-column mb-0 w-100" id="menu">
                                <li className="nav-item w-100" onClick={closeSidebar}>
                                    <Link to="/win11-control-room" className={isActive('/win11-control-room')}>
                                        <i className="bi bi-grid-fill nav-icon me-3 fs-5"></i>
                                        <span className="fw-semibold">Dashboard</span>
                                    </Link>
                                </li>

                                <li className="nav-item w-100" onClick={closeSidebar}>
                                    <Link to="/win11-control-room/users" className={isActive('/win11-control-room/users')}>
                                        <i className="bi bi-people-fill nav-icon me-3 fs-5"></i>
                                        <span className="fw-semibold">Users</span>
                                    </Link>
                                </li>
                                <li className="nav-item w-100" onClick={closeSidebar}>
                                    <Link to="/win11-control-room/create-template" className={isActive('/win11-control-room/create-template')}>
                                        <i className="bi bi-layout-text-window nav-icon me-3 fs-5"></i>
                                        <span className="fw-semibold">Create Template</span>
                                    </Link>
                                </li>
                                <li className="nav-item w-100" onClick={closeSidebar}>
                                    <Link to="/win11-control-room/manage-banners" className={isActive('/win11-control-room/manage-banners')}>
                                        <i className="bi bi-images nav-icon me-3 fs-5"></i>
                                        <span className="fw-semibold">Manage Banners</span>
                                    </Link>
                                </li>
                            </ul>

                            <div className="small text-white-50 fw-bold mt-4 mb-2 px-3 text-uppercase" style={{ fontSize: '11px', letterSpacing: '1px' }}>Finance & Ops</div>

                            <ul className="nav nav-pills flex-column mb-0 w-100">
                                <li className="nav-item w-100" onClick={closeSidebar}>
                                    <Link to="/win11-control-room/kyc" className={isActive('/win11-control-room/kyc')}>
                                        <i className="bi bi-person-vcard-fill nav-icon me-3 fs-5"></i>
                                        <span className="fw-semibold">KYC Requests</span>
                                    </Link>
                                </li>
                                <li className="nav-item w-100" onClick={closeSidebar}>
                                    <Link to="/win11-control-room/kyc-history" className={isActive('/win11-control-room/kyc-history')}>
                                        <i className="bi bi-clock-history nav-icon me-3 fs-5"></i>
                                        <span className="fw-semibold">KYC History</span>
                                    </Link>
                                </li>

                                <li className="nav-item w-100" onClick={closeSidebar}>
                                    <Link to="/win11-control-room/player-roles" className={isActive('/win11-control-room/player-roles')}>
                                        <i className="bi bi-person-gear nav-icon me-3 fs-5"></i>
                                        <span className="fw-semibold">Fix Player Roles</span>
                                    </Link>
                                </li>

                                <li className="nav-item w-100" onClick={closeSidebar}>
                                    <Link to="/win11-control-room/match-settlements" className={isActive('/win11-control-room/match-settlements')}>
                                        <i className="bi bi-cash-coin nav-icon me-3 fs-5"></i>
                                        <span className="fw-semibold">Match Settlements</span>
                                    </Link>
                                </li>

                                <li className="nav-item w-100" onClick={closeSidebar}>
                                    <Link to="/win11-control-room/settings" className={isActive('/win11-control-room/settings')}>
                                        <i className="bi bi-gear-fill nav-icon me-3 fs-5"></i>
                                        <span className="fw-semibold">Settings</span>
                                    </Link>
                                </li>
                            </ul>

                            <div className="small text-white-50 fw-bold mt-4 mb-2 px-3 text-uppercase" style={{ fontSize: '11px', letterSpacing: '1px' }}>Help & Support</div>

                            <ul className="nav nav-pills flex-column mb-0 w-100">
                                <li className="nav-item w-100" onClick={closeSidebar}>
                                    <Link to="/win11-control-room/ticket-support" className={isActive('/win11-control-room/ticket-support')}>
                                        <i className="bi bi-headset nav-icon me-3 fs-5"></i>
                                        <span className="fw-semibold">Ticket Support</span>
                                    </Link>
                                </li>
                                <li className="nav-item w-100" onClick={closeSidebar}>
                                    <Link to="/win11-control-room/account-deletion-requests" className={isActive('/win11-control-room/account-deletion-requests')}>
                                        <i className="bi bi-person-dash-fill nav-icon me-3 fs-5"></i>
                                        <span className="fw-semibold">Delete Requests</span>
                                    </Link>
                                </li>
                            </ul>
                        </div>

                        {/* --- ADMIN PROFILE FOOTER (FIXED AT BOTTOM) --- */}
                        <div className="p-3 m-3 rounded-4 mt-auto" style={{ background: 'rgba(255,255,255,0.05)', flexShrink: 0 }}>
                            {loading ? (
                                <div className="placeholder-glow d-flex align-items-center">
                                    <span className="placeholder rounded-circle bg-secondary opacity-50 me-2" style={{ width: '35px', height: '35px' }}></span>
                                    <div className="d-flex flex-column w-75">
                                        <span className="placeholder col-8 bg-secondary opacity-50 rounded mb-1"></span>
                                        <span className="placeholder col-5 bg-secondary opacity-50 rounded"></span>
                                    </div>
                                </div>
                            ) : (
                                <div className="d-flex align-items-center justify-content-between">
                                    <div className="d-flex align-items-center text-white overflow-hidden">
                                        <div className="position-relative">
                                            <img src={`https://ui-avatars.com/api/?name=${admin?.name}&background=dc3545&color=fff`} alt="" className="rounded-circle border border-2 border-danger" width="38" height="38" />
                                            <span className="position-absolute bottom-0 start-100 translate-middle p-1 bg-success border border-dark rounded-circle"></span>
                                        </div>
                                        <div className="d-flex flex-column ms-2 text-truncate">
                                            <strong style={{ fontSize: '13px' }}>{admin?.name}</strong>
                                            <small className="text-white-50" style={{ fontSize: '10px' }}>{admin?.role}</small>
                                        </div>
                                    </div>
                                    <button onClick={handleLogout} className="btn btn-link text-white-50 p-0 hover-white ms-2" title="Logout">
                                        <i className="bi bi-box-arrow-right fs-5"></i>
                                    </button>
                                </div>
                            )}
                        </div>

                    </div>
                </div>

                {/* ==============================
            MAIN CONTENT AREA
        ============================== */}
                <div className="col py-0 d-flex flex-column h-100 overflow-hidden w-100 ps-0" style={{ marginLeft: showSidebar ? '0' : '0' }}>

                    {/* FLOATING HEADER */}
                    <nav className="navbar navbar-expand-lg top-navbar px-4 py-3 mb-4 d-flex align-items-center justify-content-between bg-white shadow-sm mx-3 mt-3 rounded-4">

                        <div className="d-flex align-items-center">
                            <button className="btn btn-light d-lg-none me-3 shadow-sm text-danger" onClick={toggleSidebar}>
                                <i className="bi bi-list fs-4"></i>
                            </button>
                            <h5 className="mb-0 fw-bold text-dark d-none d-md-block">Dashboard Overview</h5>
                        </div>

                        <div className="d-flex align-items-center gap-3">
                            {/* ✅ FUNCTIONAL SEARCH BAR */}
                            <div className="d-none d-md-block position-relative">
                                <input
                                    type="text"
                                    className="form-control bg-light border-0 rounded-pill ps-5"
                                    placeholder="Search user, matches..."
                                    style={{ width: '300px' }}
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                />
                                <i className="bi bi-search position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
                            </div>

                            {/* ✅ LIVE NOTIFICATIONS DROPDOWN */}
                            <div className="position-relative" ref={notifRef}>
                                <button
                                    className="btn btn-light rounded-circle position-relative shadow-sm border-0"
                                    style={{ width: '40px', height: '40px' }}
                                    onClick={() => setShowNotifications(!showNotifications)}
                                >
                                    <i className="bi bi-bell-fill text-secondary"></i>
                                    {notifications.length > 0 && (
                                        <span className="position-absolute top-0 start-100 translate-middle p-1 bg-danger border border-light rounded-circle">
                                            <span className="visually-hidden">New alerts</span>
                                        </span>
                                    )}
                                </button>

                                {/* Dropdown Menu */}
                                {showNotifications && (
                                    <div className="notif-dropdown bg-white shadow-lg rounded-4 position-absolute end-0 mt-2" style={{ width: '320px', zIndex: 1050 }}>
                                        <div className="d-flex justify-content-between align-items-center p-3 border-bottom bg-light rounded-top-4">
                                            <h6 className="fw-bold mb-0 text-dark">Live Activity</h6>
                                            <small className="text-primary" style={{ fontSize: '11px', cursor: 'pointer' }}>Mark all read</small>
                                        </div>
                                        <div style={{ maxHeight: '350px', overflowY: 'auto' }} className="custom-scrollbar">
                                            {notifications.length === 0 ? (
                                                <div className="p-4 text-center text-muted">
                                                    <i className="bi bi-bell-slash fs-3 mb-2 d-block text-secondary opacity-50"></i>
                                                    <small>No new notifications</small>
                                                </div>
                                            ) : (
                                                notifications.map((notif) => (
                                                    <div key={notif.id} className="notif-item p-3 border-bottom d-flex align-items-start hover-bg-light">
                                                        <div className={`rounded-circle bg-light d-flex align-items-center justify-content-center me-3 ${notif.color || 'text-primary'}`} style={{ width: '35px', height: '35px', flexShrink: 0 }}>
                                                            <i className={`bi ${notif.icon || 'bi-info-circle'} fs-6`}></i>
                                                        </div>
                                                        <div>
                                                            <p className="mb-0 text-dark small fw-semibold" style={{ lineHeight: '1.2' }}>{notif.message}</p>
                                                            <small className="text-muted" style={{ fontSize: '10px' }}>{new Date(notif.createdAt).toLocaleTimeString()}</small>
                                                        </div>
                                                    </div>
                                                ))
                                            )}
                                        </div>
                                        <div className="p-2 text-center bg-light border-top rounded-bottom-4">
                                            <Link to="/win11-control-room/activity" className="text-decoration-none small fw-bold" style={{ color: '#800000' }}>View Full History</Link>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </nav>

                    {/* ✅ CONTENT RENDERER (Pass Search Query to Children) */}
                    <div className="container-fluid px-4 overflow-auto h-100 pb-5 custom-scrollbar">
                        <Outlet context={{ searchQuery }} />
                    </div>

                </div>
            </div>

            <style>{`
                /* General Admin Styles */
                .hover-white:hover { color: white !important; }
                .hover-bg-light:hover { background-color: #f8f9fa; }
                
                /* 🎨 Custom Premium Scrollbar */
                .custom-scrollbar::-webkit-scrollbar {
                    width: 5px;
                }
                .custom-scrollbar::-webkit-scrollbar-track {
                    background: transparent;
                }
                .custom-scrollbar::-webkit-scrollbar-thumb {
                    background: rgba(128, 128, 128, 0.3);
                    border-radius: 10px;
                }
                .custom-scrollbar::-webkit-scrollbar-thumb:hover {
                    background: rgba(128, 0, 0, 0.6); /* Maroon touch on hover */
                }

                /* Active Link styling for Sidebar */
                .active-link {
                    background-color: white;
                    color: #dc3545 !important;
                }
                
                /* Mobile sidebar styling */
                @media (max-width: 991.98px) {
                    .admin-sidebar-container {
                        position: fixed;
                        top: 0;
                        left: -280px;
                        height: 100vh;
                        box-shadow: 5px 0 15px rgba(0,0,0,0.1);
                    }
                    .admin-sidebar-container.show {
                        left: 0;
                    }
                }
            `}</style>
        </div>
    );
};

export default AdminLayout;